export default __webpack_public_path__ + "static/media/plain-sticker-I.2bbb3327.png";